// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Spacer_inline_9hI_t{display:inline}\n", "",{"version":3,"sources":["webpack-internal:///./node_modules/@foxford/ui/es/components/Spacer/Spacer.sass"],"names":[],"mappings":"AAQA,qBACE,cAAe","file":"Spacer.sass","sourcesContent":["@import '../../utils/variables';\n@import '../../utils/utils';\n\n@value sides #{$sides} {}\n@value sizes #{$sizes} {}\n\n.root {}\n\n.inline {\n  display: inline; }\n"]}]);
// Exports
exports.locals = {
	"sides": "(\"top\":\"top\",\"right\":\"right\",\"bottom\":\"bottom\",\"left\":\"left\")",
	"sizes": "(\"xxxl\":44px,\"xxl\":40px,\"xl\":36px,\"l\":28px,\"m\":24px,\"s\":20px,\"xs\":16px,\"xxs\":8px,\"xxxs\":4px,\"60\":60px,\"56\":56px,\"52\":52px,\"48\":48px,\"44\":44px,\"40\":40px,\"36\":36px,\"32\":32px,\"28\":28px,\"24\":24px,\"20\":20px,\"16\":16px,\"12\":12px,\"8\":8px,\"4\":4px,\"2\":2px,\"0\":0px)",
	"inline": "Spacer_inline_9hI_t"
};
module.exports = exports;
